import { render, staticRenderFns } from "./TriviaSetting.vue?vue&type=template&id=2f5f5e0c&scoped=true"
import script from "./TriviaSetting.vue?vue&type=script&lang=js"
export * from "./TriviaSetting.vue?vue&type=script&lang=js"
import style0 from "./TriviaSetting.vue?vue&type=style&index=0&id=2f5f5e0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5f5e0c",
  null
  
)

export default component.exports